// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
export class ViewDataFetchAction extends TypedAction(ActionType.ViewDataFetchAction) {
    isLoggingEnabled() {
        /**
         * This action is handled and logged via the performance marker API from
         * within the performance collection store so we don't need to log them here.
         */ return false;
    }
    constructor(viewId, state, extraData){
        super(), this.viewId = viewId, this.state = state, this.extraData = extraData;
    }
}
export class ViewForceDataFetchAction extends TypedAction(ActionType.ViewForceDataFetchAction) {
    isLoggingEnabled() {
        return false;
    }
    constructor(viewId, shouldForceFetch){
        super(), this.viewId = viewId, this.shouldForceFetch = shouldForceFetch;
    }
}
